import React from 'react';

import { TextField } from '../abstract/forms/textfield';

export const TextInput = ({ field, form: { touched, errors }, ...props }) => {
  const hasError = touched[field.name] && errors[field.name];

  return <TextField hasError={hasError} errorMessage={errors[field.name]} {...field} {...props} />;
};
